import React from "react"

//Utils
import Seo from "components/seo"

//Components
import OurStoreComp from "@components/pages/our-store"
import Layout from "components/layout"
import { F_Q_STORE_INFO } from "lib/function"

const OurStore = ({ data, locale }) => {
  return (
    <>
      <Seo title="Our Store" />
      <Layout>
        <OurStoreComp data={data} locale={locale} />
      </Layout>
    </>
  )
}

export default OurStore

export const getStaticProps = async (ctx) => {
  let token = process.env.INIT_TOKEN
  let { locale } = ctx

  let data = await F_Q_STORE_INFO({ lang: locale }, token)
  return {
    props: { data: data?.data?.storeInfo ?? {}, locale },
    revalidate: 60,
  }
}
